module.exports = __webpack_public_path__ + "static/media/RI-D5-5.3-043.117b76a6.webp";